import React, { useEffect, useRef, useState } from "react";
import styles from "./UserProfilePage.module.scss";
import { useLocation, useParams } from "react-router-dom";
import HomeSVG from "../../components/SVGComponents/HomeSVG";
import ImageSVG from "../../components/SVGComponents/ImageSVG";
import VideosSVG from "../../components/SVGComponents/VideosSVG";
import SocialPostComponent from "../../components/SocialPostComponent/SocialPostComponent";
import SkillsCardComponent from "../../components/UserProfile/SkillsCardsComponent/SkillsCardComponent";
// import { filesAPI } from "../../service/apiUrl";
import Button from "../../components/UI/Button/Button";
import CopyTextSVG from "../../components/SVGComponents/CopyTextSVG";
import Modal from "../../components/Modal/Modal";
import FollowersList from "../../components/Followers/FollowersList/FollowersList";
import { serverFiles } from "../../utils/utils";
import ProfileSVG from "../../components/SVGComponents/ProfileSVG";
import UserResume from "../../components/UserResume/UserResume";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfile,
  getOtherUserProfile,
  resetOtherUserProfile,
} from "../../reducer/profileSlice";
import { followUser, unfollowUser } from "../../reducer/profileSlice";
import { sentEmailRequest } from "../../reducer/requestEmailSlice";
import toast from "../../components/Toast/toast";
import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import { getAllPosts } from "reducer/postsSlice";
import Tooltip from "components/common/Tooltip/Tooltip";
import DownloadIconSVG from "components/SVGComponents/DownloadIconSVG";
import PDFPreview from "components/common/PDFPreview/PDFPreview";
import UserProfileSkeleton from "./UserProfileSkeleton";
// import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import NO_IMAGE from "../../images/NO_IMAGE.jpg";
import Suitcase from "components/SVGComponents/Suitcase";
import no_profile_posts_image from "../../images/errorImages/profileNoPosts.png";

const UserProfilePage = () => {
  const { userPosts, isPostsLoading } = useSelector((state) => state.posts);

  const followBtnRef = useRef(0);
  const requestEmailRef = useRef(0);
  const delay = 2000;

  const [postSelector, setPostSelector] = useState("HOME");
  const [followModal, setFollowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const { pathname } = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const { userProfile, otherUserProfile } = useSelector(
    (state) => state.userProfile
  );

  const currentUserId =
    userProfile?.userAliasId || userProfile?.companyResponseDto?.companyAliasId;

  const otherUserId =
    otherUserProfile?.userAliasId ||
    otherUserProfile?.companyResponseDto?.companyAliasId;
  const profileData = id ? otherUserProfile : userProfile;

  const isBusiness = profileData?.userType === "BUSINESS";
  const userProfileImage = profileData?.profileUrl;
  const companyLogo = profileData?.profileUrl;

  const imageSrc = isBusiness
    ? (companyLogo && serverFiles(companyLogo)) || NO_IMAGE
    : serverFiles(userProfileImage) || NO_IMAGE;

  const followOtherUser = async (type) => {
    const now = Date.now();
    if (now - followBtnRef.current >= delay) {
      followBtnRef.current = now;

      const payload = {
        userAliasId: otherUserId,
      };

      try {
        if (type === "FOLLOW") {
          await dispatch(followUser({ payload, postId: null }));
        } else if (type === "UNFOLLOW") {
          await dispatch(unfollowUser({ payload, postId: null }));
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const requestEmail = async () => {
    const now = Date.now();

    if (now - requestEmailRef.current >= delay) {
      requestEmailRef.current = now;

      try {
        const res = await dispatch(sentEmailRequest(profileData?.userAliasId));
        //console.log(res?.payload);
        // if (res?.payload === true) {
        //   setShowRequestEmailButton("PENDING");
        // }
      } catch (error) {
        toast.error(error.message || "Something wrong in requesting an email");
      }
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    dispatch(resetOtherUserProfile());
    setFollowModal(false);
  }, [pathname]);

  useEffect(() => {
    if (id) {
      dispatch(getOtherUserProfile(id));
      dispatch(getAllPosts({ postOwnerId: otherUserId }));
    } else {
      dispatch(getUserProfile());
      dispatch(getAllPosts({ postOwnerId: currentUserId }));
    }
  }, [id, dispatch, otherUserId, currentUserId]);

  const userData = {
    userAliasId: profileData?.userAliasId,
    mobileNo: profileData?.mobileNo || "N/A",
    gender: profileData?.gender || "N/A",
    state: {
      name: profileData?.stateName || "N/A",
    },
    city: {
      name: profileData?.cityName || "N/A",
    },
    educations: profileData?.educations || [],
    workExperiences: profileData?.workExperiences || [],
    skills: profileData?.skills || [],
    otherActivities: profileData?.otherActivities || [],
    industry: profileData?.industry || [],
    categories: profileData?.categories || [],
  };

  return (
    <section className={styles.user_profile_main}>
      {/* {isLoading && <UserProfileSkeleton />} */}

      {!isPostsLoading ? (
        <>
          <section className={styles.user_profile_left}>
            <section className={styles.user_profile_details}>
              {/* {profileImage || userProfile?.companyResponseDto?.logo ? (
                <>
                  {profileData?.userType === "BUSINESS" ? (
                    <img
                      className={styles.user_profile_image}
                      src={
                        profileData?.companyResponseDto?.logo &&
                        serverFiles(profileData?.companyResponseDto?.logo)
                      }
                      alt=""
                    />
                  ) : (
                    <img
                      className={styles.user_profile_image}
                      src={profileImage}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = NO_IMAGE;
                      }}
                      alt=""
                    />
                  )}
                </>
              ) : (
                <>
                  <img
                    className={styles.user_profile_image}
                    src={NO_IMAGE}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = NO_IMAGE;
                    }}
                    alt=""
                  />
                </>
              )} */}

              <img
                className={styles.user_profile_image}
                src={imageSrc}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = NO_IMAGE;
                }}
                alt=""
              />

              <div className={styles.user_profile_description}>
                {profileData?.userType === "CREATOR" && (
                  <p className={styles.user_profile_username}>
                    {`${profileData?.firstName || ""} ${
                      profileData?.lastName || ""
                    }`}
                  </p>
                )}

                {profileData?.userType === "BUSINESS" && (
                  <div className={styles.business}>
                    <p className={styles.user_profile_username}>
                      {`${profileData?.companyResponseDto?.name || ""}`}
                    </p>
                    <Suitcase height="18" width="18" />
                  </div>
                )}

                {profileData?.userType === "BUSINESS" && (
                  <p className={styles.user_profile_education}>
                    {`Est. - ${
                      profileData?.companyResponseDto?.establishmentYear || ""
                    }`}
                  </p>
                )}

                <div className={styles.user_profile_education}>
                  {profileData?.educations?.length > 0 && (
                    <Tooltip
                      force={true}
                      place="bottom"
                      data={profileData?.industry?.map((ind) => ind).join(", ")}
                    >
                      {profileData?.industry[0]}
                    </Tooltip>
                  )}
                </div>
                {profileData?.status === "ACCEPT" && (
                  <p className={styles.user_profile_email}>
                    <CopyTextSVG
                      text={profileData?.email}
                      success="Email Copied Successfully"
                      error="Cannot Copy Email ID"
                      height={16}
                      width={16}
                    />

                    {profileData?.email}
                  </p>
                )}

                {/* {otherUserProfile?.userType === "CREATOR" && ( */}
                <>
                  {otherUserId !== undefined &&
                    otherUserId !== currentUserId && (
                      <section className={styles.buttonSection}>
                        <div className={styles.follow_buttons}>
                          {profileData?.userType === "CREATOR" && (
                            <Button
                              variant="outlined"
                              onClick={requestEmail}
                              disabled={profileData?.status !== null}
                            >
                              {!profileData?.status
                                ? "Request Email"
                                : "Requested Email"}
                            </Button>
                          )}
                        </div>
                        <div className={styles.follow_buttons}>
                          {otherUserProfile?.isFollowed ? (
                            <Button
                              onClick={() => followOtherUser("UNFOLLOW")}
                              variant={"outlined"}
                            >
                              Unfollow
                            </Button>
                          ) : (
                            <Button
                              onClick={() => followOtherUser("FOLLOW")}
                              variant={"filled"}
                            >
                              Follow
                            </Button>
                          )}
                        </div>
                      </section>
                    )}
                </>

                <div className={styles.followers_following_section}>
                  <div className={styles.followers}>
                    {profileData?.followerCount || 0}{" "}
                    <span
                      onClick={() => {
                        setFollowModal((prev) => !prev);
                        setModalType("FOLLOWERS");
                      }}
                    >
                      Followers
                    </span>
                  </div>
                  <div className={styles.followers_seperator}></div>
                  <div className={styles.followers}>
                    {profileData?.followingCount || 0}{" "}
                    <span
                      onClick={() => {
                        setFollowModal((prev) => !prev);
                        setModalType("FOLLOWING");
                      }}
                    >
                      Following
                    </span>
                  </div>
                </div>

                <Modal
                  modalOpen={followModal}
                  onClose={() => setFollowModal(false)}
                  width="30rem"
                  drawer={{
                    isDrawer: true,
                    position: "bottom",
                    mobileOnly: false,
                  }}
                  background="white"
                >
                  <FollowersList
                    onClose={() => setFollowModal(false)}
                    modalType={modalType}
                    userId={
                      profileData?.userAliasId ||
                      profileData?.companyResponseDto?.companyAliasId
                    }
                  />
                </Modal>
              </div>
            </section>
            {profileData?.userType === "CREATOR" && (
              <SkillsCardComponent
                skills={profileData?.skills}
                className={styles.hidden_display}
              />
            )}
          </section>
          <section className={styles.user_posts_right_section}>
            {profileData?.userType === "BUSINESS" && (
              <section className={styles.AboutSection}>
                <p>About</p>
                <p>
                  {profileData?.companyResponseDto?.about ||
                    "No description available."}
                </p>
              </section>
            )}

            <section className={styles.user_post_type_selector}>
              <div
                onClick={() => setPostSelector("HOME")}
                className={`${styles.post_type_selector} ${
                  postSelector === "HOME" ? `${styles.selector_selected}` : ""
                }`}
              >
                <HomeSVG />
                Posts
              </div>

              {profileData?.userType === "CREATOR" && (
                <div
                  onClick={() => setPostSelector("PROFILE")}
                  className={`${styles.post_type_selector} ${
                    postSelector === "PROFILE"
                      ? `${styles.selector_selected}`
                      : ""
                  }`}
                >
                  <ProfileSVG />
                  {otherUserId !== undefined && otherUserId !== currentUserId
                    ? "Profile"
                    : "My Profile"}
                </div>
              )}
            </section>
            <section className={styles.contentPage}>
              {postSelector === "HOME" && (
                <section className={styles.posts_feed}>
                  {userPosts?.length ? (
                    userPosts?.map((post) => (
                      <SocialPostComponent key={post?.id} post={post} />
                    ))
                  ) : (
                    <div className={styles.no_profile_posts}>
                      <img
                        src={no_profile_posts_image}
                        alt=""
                        className={styles.no_profile_posts_image}
                      />

                      <p className={styles.no_profile_posts_text}>
                        Nothing posted yet
                      </p>
                    </div>
                  )}
                </section>
              )}

              {postSelector === "PROFILE" &&
                profileData?.userType === "CREATOR" && (
                  <section className={styles.profileDetails}>
                    {/* My Profile Page*/}
                    <UserResume data={userData} showLine={true} />
                    {otherUserId === undefined &&
                      currentUserId !== otherUserId &&
                      profileData?.portfolioUrl && (
                        <div className={styles.portfolioSection}>
                          <p className={styles.pbm}>Portfolio</p>
                          <div>
                            <PDFPreview
                              url={serverFiles(profileData?.portfolioUrl)}
                            />
                          </div>
                          <div className={styles.downloadBtnSection}>
                            <p>Max. files size : 20MB</p>
                            <a
                              href={`${serverFiles(profileData?.portfolioUrl)}`}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <button>
                                <DownloadIconSVG />
                                <p>Download</p>
                              </button>
                            </a>
                          </div>
                        </div>
                      )}
                  </section>
                )}
            </section>
          </section>
          {/* </section> */}
        </>
      ) : (
        <>
          <UserProfileSkeleton />
        </>
      )}
    </section>
  );
};

export default UserProfilePage;
